// extracted by mini-css-extract-plugin
module.exports = {"formNote":"mergeParticipantsFormFields_formNote__1-NMj","warning":"mergeParticipantsFormFields_warning__30tmZ"};